export const MINIMUM_ZIP_LENGTH = 4;
